
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinar/[title]",
      function () {
        return require("private-next-pages/webinar/[title].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinar/[title]"])
      });
    }
  